import _ from 'lodash'
import DataType from 'scoreboard/datasets/model/data-type'
const { DATE } = DataType

/**
 * Returns the value to display an aggregated value taking into account how
 * to display blanks based on the data type and aggregation type the value
 * represents
 *
 * @param {Object} value the value to format
 * @param {Object} aggregation object holding aggregation attributes (data type,
 * aggregation type)
 * @param [Boolean=false] opts.other true if this is for an "Other" row
 */
function coerceNilAggregatedValue(value, aggregation, opts = {}) {
	let isBlank =  _.isNil(value)
	let other = _.get(opts, 'other', false)
	// note: the logic for changing the value to 0 should match the
	// logic in DatasetsQueryDao.isNullChangedToZero

	// #35735 show 0 instead of blank for # unique, but not for the
	// "Other" row
	if (!other && isBlank && aggregation.aggregationType === 'unique') {
		return 0
	}

	// #38618 sum and percentage aggregations should use 0
	if (isBlank && (
		aggregation.aggregationType === 'sum' ||
		aggregation.aggregationType === 'percentage'
	)) {
		// #15580 don't set dates to 0
		return aggregation.dataType === DATE ? null : 0
	}

	return value
}

export default coerceNilAggregatedValue
coerceNilAggregatedValue.__filename__ = 'components/coerce-nil-aggregated-value.js'
